// extracted by mini-css-extract-plugin
export default {"content":"DeleteItemPopup_content__pCS4+"};